"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = exports.ConnectButton = exports.COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _Spinner = _interopRequireDefault(require("@concur/nui-widgets/lib/Spinner/Spinner"));
var _AutoConnectInput = _interopRequireDefault(require("./AutoConnectInput"));
var _listingModule = require("./listingModule");
var termsModule = _interopRequireWildcard(require("../terms/termsModule"));
var analyticsModule = _interopRequireWildcard(require("../analytics/modules/AnalyticsModule"));
var _config = _interopRequireDefault(require("../config"));
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/listingDetails.css") : void 0;
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/connectButton.css") : void 0;
var _analytics = require("../constants/analytics");
var _withAppContext = require("../HOCs/withAppContext");
var _index = require("../utils/index");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// can remove with triplink-app-flags beta flag cleanup

var COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = exports.COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = 1;
var SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = exports.SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = 2;
var ConnectButton = exports.ConnectButton = function ConnectButton(_ref) {
  var listing = _ref.listing,
    inquire = _ref.inquire,
    userId = _ref.userId,
    isDisabled = _ref.isDisabled,
    launchTaCModal = _ref.launchTaCModal,
    launchModal = _ref.launchModal,
    modalNames = _ref.modalNames,
    connectToListing = _ref.connectToListing,
    disconnectFromListing = _ref.disconnectFromListing,
    terms = _ref.terms,
    isConnecting = _ref.isConnecting,
    trackLinkClick = _ref.trackLinkClick,
    trackButtonClick = _ref.trackButtonClick,
    companyUUID = _ref.companyUUID,
    _ref$userProfile = _ref.userProfile,
    userProfile = _ref$userProfile === void 0 ? {} : _ref$userProfile,
    trackInteractionEvent = _ref.trackInteractionEvent,
    betas = _ref.betas,
    isTestEntity = _ref.isTestEntity;
  var ID = listing.ID,
    _listing$core = listing.core,
    flow = _listing$core.oAuthWorkflowType,
    isUserConnected = _listing$core.isUserConnected,
    supportNewEnrollment = _listing$core.supportNewEnrollment,
    isConnectionPending = _listing$core.isConnectionPending,
    listingName = _listing$core.listingName,
    listingType = _listing$core.listingType,
    triplinkLoyaltyNumber = _listing$core.triplinkLoyaltyNumber,
    clientOptInType = _listing$core.clientOptInType,
    canUserConnect = _listing$core.canUserConnect,
    v1ID = _listing$core.v1ID,
    isTriplinkDisabledApp = _listing$core.isTriplinkDisabledApp,
    dnfRequired = listing.dnfRequired,
    dnfCompleted = listing.dnfCompleted,
    _listing$localized = listing.localized,
    connectURL = _listing$localized.connectURL,
    inquireURL = _listing$localized.inquireURL,
    hasCustomDisconnectUrl = listing.hasCustomDisconnectUrl;
  var isDRCListing = _config.default.nui.DRCListingId === ID;
  var AUTO_CON_FLOW = 'AUTOCONFLOW';
  var ADMIN = 'ADMIN';
  var btnStyle = {
    width: '98%',
    minWidth: '150px',
    marginTop: '16px'
  };
  if ((0, _index.canAccessBeta)(betas, 'triplink-app-flags')) {
    if (isTriplinkDisabledApp) {
      isDisabled = true;
    }
  }
  function isCompanyAdminOrWSAdmin() {
    var role = userProfile && userProfile.profile && userProfile.profile.Role;
    return role === COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE;
  }
  function isSystemAdminOrConcurAdmin() {
    var role = userProfile && userProfile.profile && userProfile.profile.Role;
    return role === SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE;
  }
  function canConnectToEnterpriseApp() {
    return isCompanyAdminOrWSAdmin() || isSystemAdminOrConcurAdmin();
  }
  function handleLaunchTaC(options) {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.connect],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    launchTaCModal(_objectSpread({
      tAndCLinkClicked: false,
      flow: flow,
      listingId: listing.ID,
      v1ListingId: v1ID,
      needAnAccountClicked: false
    }, options));
  }
  function connectBtn(btnDisabled) {
    var formatConnect = btnDisabled ? /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontStyle: 'italic'
      }
    }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "Connect"
    })) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "Connect"
    });
    return canUserConnect && /*#__PURE__*/_react.default.createElement(_Button.default, {
      id: "listing-appcenter-flow-connect-button",
      onClick: handleLaunchTaC,
      style: btnStyle,
      disabled: btnDisabled || (flow === AUTO_CON_FLOW && !listing.loyaltyNumber || isConnecting) && !triplinkLoyaltyNumber
    }, isConnecting ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      size: "lg",
      type: "inline",
      className: "spinner",
      visible: isConnecting,
      message: ""
    }) : formatConnect);
  }
  function disconnectBtn() {
    var launchDisconnectModal = function launchDisconnectModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.disconnect],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      if (hasCustomDisconnectUrl) {
        disconnectFromListing(ID, v1ID);
      } else {
        launchModal(modalNames.disconnect);
      }
    };

    // this removes the ability to disconnect from mobile
    if (connectURL && connectURL.indexOf('profile/profile_mobile.asp') !== -1) {
      return null;
    }
    return (clientOptInType === 'USER' || canConnectToEnterpriseApp()) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: launchDisconnectModal,
      style: btnStyle
    }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "Disconnect"
    }));
  }
  function connectOrDisconnectBtn(btnDisabled) {
    return !isUserConnected ? connectBtn(btnDisabled) : disconnectBtn();
  }
  function handleInquireClicked(elementType) {
    trackInteractionEvent({
      elementType: elementType,
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.ReqInfo],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    _nuiLogger.default.info({
      description: "Inquire button clicked on listing ".concat(ID),
      'cte.subcategory': 'inquire-button-click'
    });
    window.open(inquireURL, 'Inquire', 'noopener,noreferrer');
    return inquire(listing.ID, userId);
  }
  var renderConnectedCheck = function renderConnectedCheck() {
    return userId && isUserConnected && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "is-connected-check-details icon-check icon-size-md"
    }), /*#__PURE__*/_react.default.createElement("h4", {
      className: "connection-message"
    }, listingType === 'ACONCT' ?
    /*#__PURE__*/
    // Use "EnrolledNew" when beta check is removed
    _react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: (0, _index.canAccessBeta)(betas, 'triplink-app-flags') ? 'EnrolledNew' : 'Enrolled'
    }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "Connected"
    })));
  };
  function requestInfoBtnAndDescription() {
    var deeplinkToListing = function deeplinkToListing() {
      window.location = "".concat(_config.default.CTEUrl, "?hpo=20&cte=").concat(listing.ID);
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        textAlign: 'left'
      }
    }, !isUserConnected && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      style: btnStyle,
      onClick: function onClick() {
        return handleInquireClicked(_analytics.elementList.button);
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontStyle: 'italic'
      }
    }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "RequestInformation"
    }))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "RequestInformationDescription"
    }), connectURL && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "link",
      muted: userId && !canConnectToEnterpriseApp() || isDisabled,
      disabled: userId && !canConnectToEnterpriseApp() || isDisabled,
      style: {
        padding: '0px',
        textAlign: 'left'
      },
      onClick: function onClick() {
        if (userId) {
          return handleLaunchTaC();
        }
        return deeplinkToListing();
      }
    }, userId ? /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "Connect"
    }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "LoginToConnect"
    })), /*#__PURE__*/_react.default.createElement("br", null), canConnectToEnterpriseApp() ? /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "ConnectBusinessApp"
    }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "EndUserConnectBusinessApp"
    }))));
  }
  function requestInfoLinkAndDescription() {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        textAlign: 'left',
        paddingTop: '16px'
      }
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      onClick: function onClick() {
        return handleInquireClicked(_analytics.elementList.link);
      }
    }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "RequestInformation"
    })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "RequestInformationDescription"
    }));
  }
  function getDRCLinkAndDescription() {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        textAlign: 'left',
        paddingTop: '16px'
      }
    }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "AppCenterV2.connectButton.dRCDescription"
    }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      onClick: function onClick() {
        return handleInquireClicked(_analytics.elementList.link);
      }
    }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "AppCenterV2.connectButton.dRCLinkText2"
    })));
  }
  function inquireBtn() {
    if (listingType === 'COCPAP') {
      if (canConnectToEnterpriseApp()) {
        var _userProfile$profile = userProfile.profile,
          _userProfile$profile2 = _userProfile$profile === void 0 ? {} : _userProfile$profile,
          _betas = _userProfile$profile2.betas;
        // This indicates if the user is subject to potential listing connection blocking
        var blockIncompleteDnf = (_config.default.nui.forceIncompleteDnfConnectionBlocking || _config.default.nui.enableIncompleteDnfConnectionBlocking && _betas['dnf-consumer']) && !isTestEntity;
        // This indicates if the listing connection is blocked due to incomplete dnf
        var isConnectionBlocked = blockIncompleteDnf && dnfRequired && !dnfCompleted;
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            textAlign: 'left'
          }
        }, !isUserConnected && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "ActivateBusinessApp"
        })), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "ConnectBusinessApp"
        })), connectOrDisconnectBtn(isDisabled || isConnectionBlocked), !isUserConnected && isConnectionBlocked && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "AppCenterV2.listing.dnfExplanation"
        })), isDRCListing ? getDRCLinkAndDescription() : requestInfoLinkAndDescription());
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: 'left'
        }
      }, connectOrDisconnectBtn(true), !isUserConnected && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "EndUserConnectBusinessApp"
      })), isDRCListing ? getDRCLinkAndDescription() : requestInfoLinkAndDescription());
    }
    return requestInfoBtnAndDescription();
  }
  function enrollBtn() {
    var launchEnrollModal = function launchEnrollModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.enroll],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.enroll);
      (0, _listingModule.checkForConnection)(ID, v1ID);
    };
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      style: btnStyle,
      onClick: launchEnrollModal,
      disabled: isDisabled || isConnecting
    }, isConnecting ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      size: "lg",
      type: "inline",
      className: "spinner",
      visible: isConnecting,
      message: ""
    }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "Enroll"
    }));
  }
  function unenrollBtn() {
    var launchUnenrollModal = function launchUnenrollModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.unenroll],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.unenroll);
      (0, _listingModule.checkForConnection)(ID, v1ID);
    };
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      style: btnStyle,
      onClick: launchUnenrollModal
    }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "Unenroll"
    }));
  }
  function enrollOrUnenrollBtn() {
    return !isUserConnected ? enrollBtn() : unenrollBtn();
  }
  function loginToConnectBtn() {
    var deeplinkToListing = function deeplinkToListing() {
      window.location = "".concat(_config.default.CTEUrl, "?hpo=20&cte=").concat(listing.ID);
    };
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      style: btnStyle,
      onClick: deeplinkToListing
    }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "LoginToConnect"
    })), isDRCListing && getDRCLinkAndDescription(), !isDRCListing && inquireURL ? requestInfoLinkAndDescription() : null);
  }
  function showBtn() {
    if (userId) {
      if (isConnectionPending && !isUserConnected) {
        return;
      }
      if (clientOptInType === ADMIN) {
        return inquireBtn();
      }
      if (listingType === 'COCPAP') {
        return connectOrDisconnectBtn(isDisabled);
      }
      return enrollOrUnenrollBtn();
    }
    if (listingType === 'ADVISR') {
      return inquireBtn();
    }
    return loginToConnectBtn();
  }
  function showNeedAnAccountLink() {
    var launchTaC = function launchTaC(e) {
      trackLinkClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.connectLoyaltyNumber, _analytics.needAnAccountLink, _analytics.launchTAndC],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      e.preventDefault();
      handleLaunchTaC({
        needAnAccountClicked: true
      });
    };
    var connectWithoutTaC = function connectWithoutTaC(e) {
      trackLinkClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.connectLoyaltyNumber, _analytics.needAnAccountLink, _analytics.connectWithoutTAndC],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      e.preventDefault();
      connectToListing(ID, v1ID, {
        needAnAccountClicked: true
      });
    };
    var areTermsAccepted = function areTermsAccepted() {
      if (terms) {
        return terms.previouslyAccepted || terms.currentlyAccepted;
      }
      return false;
    };
    if (isConnectionPending || isUserConnected) {
      return null;
    }
    return !isDisabled && userId && supportNewEnrollment && !triplinkLoyaltyNumber && clientOptInType !== ADMIN && /*#__PURE__*/_react.default.createElement("p", {
      style: {
        textAlign: 'center',
        paddingBottom: '5px'
      }
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      onClick: areTermsAccepted() ? connectWithoutTaC : launchTaC
    }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "NeedAnAccount"
    })));
  }
  var renderAutoConnectInput = function renderAutoConnectInput() {
    return userId && flow === AUTO_CON_FLOW && !isConnectionPending && !isUserConnected && /*#__PURE__*/_react.default.createElement(_AutoConnectInput.default, {
      listing: listing,
      isDisabled: isDisabled
    });
  };
  var showConnectionPendingMessage = function showConnectionPendingMessage() {
    return userId && flow === AUTO_CON_FLOW && isConnectionPending && !isUserConnected && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        textAlign: 'left'
      }
    }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "ConnectionPending"
    })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("h4", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "ConnectionPendingMessage"
    })));
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: userId && (flow === AUTO_CON_FLOW || clientOptInType === ADMIN) ? 'loyalty-box' : '',
    style: {
      textAlign: 'center'
    }
  }, false && /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'red',
      fontSize: '30px'
    }
  }, userProfile.profile && userProfile.profile.LoginID), renderAutoConnectInput(), renderConnectedCheck(), showNeedAnAccountLink(), showConnectionPendingMessage(), showBtn()));
};
ConnectButton.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string,
    core: _propTypes.default.object,
    images: _propTypes.default.object,
    localized: _propTypes.default.object,
    loyaltyNumber: _propTypes.default.string,
    v1data: _propTypes.default.object,
    hasCustomDisconnectUrl: _propTypes.default.bool
  }).isRequired,
  modalNames: _propTypes.default.shape({
    confirmation: _propTypes.default.string,
    disconnect: _propTypes.default.string,
    enroll: _propTypes.default.string,
    unenroll: _propTypes.default.string
  }).isRequired,
  terms: _propTypes.default.shape({
    appcenterStatus: _propTypes.default.object,
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    ereceiptTerms: _propTypes.default.string,
    sharedInfoStatus: _propTypes.default.object
  }).isRequired,
  userId: _propTypes.default.string,
  connectToListing: _propTypes.default.func.isRequired,
  disconnectFromListing: _propTypes.default.func.isRequired,
  inquire: _propTypes.default.func.isRequired,
  launchTaCModal: _propTypes.default.func.isRequired,
  launchModal: _propTypes.default.func.isRequired,
  isDisabled: _propTypes.default.bool.isRequired,
  isConnecting: _propTypes.default.bool.isRequired,
  trackLinkClick: _propTypes.default.func,
  trackButtonClick: _propTypes.default.func,
  trackInteractionEvent: _propTypes.default.func,
  companyUUID: _propTypes.default.string,
  betas: _propTypes.default.object,
  isTestEntity: _propTypes.default.bool
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isConnecting: state.listing.isConnecting,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    terms: state.terms,
    companyUUID: state.userPrefs.companyUUID,
    userProfile: state.userProfile,
    betas: state.betas || {},
    isTestEntity: state.userPrefs.isTestEntity
  };
};
var _default = exports.default = (0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, {
  launchModal: _listingModule.toggleModal,
  inquire: _listingModule.inquireListing,
  connectToListing: _listingModule.connectListing,
  launchTaCModal: termsModule.launchTaCModal,
  checkForConnection: _listingModule.checkForConnection,
  disconnectFromListing: _listingModule.disconnectListing,
  trackLinkClick: analyticsModule.linkClickDispatch,
  trackButtonClick: analyticsModule.buttonClickDispatch,
  trackInteractionEvent: analyticsModule.interactionEventDispatch
})(ConnectButton));